// extracted by mini-css-extract-plugin
module.exports = {"body":"Login_body__352Aj","logo":"Login_logo__1tOkP","login":"Login_login__L32O8","caption":"Login_caption__EOI8X","text":"Login_text__2Bzyz"};